var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.394,
    height: 50.509,
    viewBox: "0 0 54.394 50.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(-17.998 -17.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_69",
    "data-name": "Groupe 69",
    transform: "translate(17.998 17.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1152",
    "data-name": "Trac\\xE9 1152",
    d: "M21.884,43.245A21.368,21.368,0,0,1,53.936,24.736a1.943,1.943,0,1,0,1.943-3.365A25.253,25.253,0,1,0,68.505,43.245a1.943,1.943,0,0,0-3.885,0,21.368,21.368,0,0,1-42.736,0Z",
    transform: "translate(-17.998 -17.988)",
    fill: "#b4a14a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1153",
    "data-name": "Trac\\xE9 1153",
    d: "M96.164,33.313a1.945,1.945,0,1,0-2.751-2.751L67.593,56.386,57.313,46.1a1.945,1.945,0,0,0-2.751,2.751L66.217,60.508a1.943,1.943,0,0,0,2.751,0Z",
    transform: "translate(-42.339 -26.106)",
    fill: "#b4a14a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.122b52446b5e9cbecbb00212c182a5e9.svg";
export { ForwardRef as ReactComponent };